import { render, staticRenderFns } from "./project-record.vue?vue&type=template&id=20e6bc81&scoped=true"
import script from "./project-record.vue?vue&type=script&lang=js"
export * from "./project-record.vue?vue&type=script&lang=js"
import style0 from "./project-record.vue?vue&type=style&index=0&id=20e6bc81&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e6bc81",
  null
  
)

export default component.exports